import { z } from 'zod';
import { MontoClpSchema, PeriodoSchema } from './common.js';

/**
 * Dashboard de transparencia — vista agregada compartida entre todos los roles.
 * El diferenciador de producto: los residentes ven los mismos datos financieros
 * que el administrador.
 */

export const DashboardSchema = z.object({
  periodoActual: PeriodoSchema,
  gastos: z.object({
    emitidoMes: MontoClpSchema,
    recaudadoMes: MontoClpSchema,
    moraPendiente: MontoClpSchema,
    tasaCobroPct: z.number().min(0).max(100),
  }),
  unidades: z.object({
    total: z.number().int().nonnegative(),
    conCargosPendientes: z.number().int().nonnegative(),
    enMora: z.number().int().nonnegative(),
  }),
  fondoReserva: z.object({
    saldo: MontoClpSchema,
    aportesMes: MontoClpSchema,
    usoMes: MontoClpSchema,
  }),
  proximosVencimientos: z.array(
    z.object({
      fechaVencimiento: z.string(),
      cantidadCargos: z.number().int().nonnegative(),
      montoTotal: MontoClpSchema,
    }),
  ),
});
export type Dashboard = z.infer<typeof DashboardSchema>;
